import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import LazyAnimation from './LazyAnimation';

const useStyles = makeStyles(theme => ({
  factContainer: {
    width: '20.875%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  factWrapper: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    padding: '27px 19px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      marginBottom: 30,
    },
  },
  factValue: {
    color: '#01619B',
    fontFamily: 'PoppinsMedium',
    fontSize: 50,
    lineHeight: '72px',
    fontWeight: '500',
    marginBottom: 20,
    textAlign: 'center',
  },
  factText: {
    fontSize: 14,
    fontFamily: 'OpenSansRegular',
    lineHeight: '1.4em',
    color: '#000000',
    textAlign: 'center',
  },
}));

const FactAnimation = ({ value, text }) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const classes = useStyles();
  const [current, setCurrent] = useState(0);
  const startTime = useRef();

  const [ref, inView] = useInView({
    rootMargin: '-100px 0px',
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      if (!startTime.current) startTime.current = Date.now();
      const interval = setInterval(() => {
        let runTime = Date.now() - startTime.current;
        if (runTime > 1000) {
          runTime = 1000;
          clearInterval(interval);
        }

        setCurrent((value * (runTime / 1000)).toFixed(0));
      }, 25);
    }
  }, [inView]);

  return (
    <div ref={ref} className={classes.factContainer}>
      <LazyAnimation
        type="fade-in"
        style={{ height: isSmDown ? 'auto' : '100%' }}
      >
        <div className={classes.factWrapper}>
          <Typography className={classes.factValue}>{current}%</Typography>
          <Typography className={classes.factText}>{text}</Typography>
        </div>
      </LazyAnimation>
    </div>
  );
};

FactAnimation.propTypes = {
  value: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
};

export default FactAnimation;
